module.exports = __webpack_public_path__ + "static/media/1stad_logo_title_nn.fa601917.png";